import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

import CommonLawResults from "components/OrderDetail/Results/CommonLawResults/CommonLawResults";
import StateSearchResults from "components/OrderDetail/Results/StateSearchResults/StateSearchResults";
import FederalSearchResults from "components/OrderDetail/Results/FederalSearchResults/FederalSearchResults";
import Pagination from "components/Pagination/Pagination";

const Content = styled.div`
  min-width: 100%;
  max-width: 100%;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  width: 100%;
  height: 0;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: 0 0;
  transition: 0.5s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      height: 100%;
      opacity: 1;
      transform: scaleY(1);
      padding: 36px 32px 56px;

      @media (max-width: ${breakpoints.mobileL}) {
        padding: 36px 0 56px;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
      }
    `}
`;

const Row = styled.div`
  display: flex;
  width: 100%;

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const DateRow = styled.div`
  display: flex;
  width: 100%;
`;
const Label = styled.div`
  padding: 16px;
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 16px;
  line-height: 12px;
  color: #7b848d;

  ${DateRow}:first-child & {
    padding-top: 14px;
  }
  ${DateRow}:last-child & {
    padding-bottom: 14px;
  }
`;
const Data = styled(Label)`
  padding-left: 24px;
  border-left: 1px solid #ecedf1;
  font-family: "Montserrat";
  font-weight: 500;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  text-align: center;
  font-weight: bold;
`;

function MonitoringReportsMobile({ monitoringReports }) {
  const [currentPage, setCurrentPage] = useState(1);

  const reportsArray = Object.keys(monitoringReports).filter((idx) => monitoringReports[idx].completed);

  const idx = reportsArray[currentPage - 1];

  return (
    <>
      <Pagination top currentPage={currentPage} totalPages={reportsArray.length} onClick={setCurrentPage} />
      {reportsArray.length ? (
        <Content isOpen>
          <Row>
            <DateRow>
              <Label>Date:</Label>
              <Data>{idx}</Data>
            </DateRow>
          </Row>
          <FederalSearchResults federalSearchResults={monitoringReports[idx].federalSearchResults} />
          <StateSearchResults stateSearchResults={monitoringReports[idx].stateSearchResults} />
          <CommonLawResults commonLawResults={monitoringReports[idx].commonLawResults} />
        </Content>
      ) : (
        <Content isOpen>
          <EmptyMessage>No Monitoring reports results found</EmptyMessage>
        </Content>
      )}
      <Pagination bottom currentPage={currentPage} totalPages={reportsArray.length} onClick={setCurrentPage} />
    </>
  );
}

MonitoringReportsMobile.propTypes = {
  monitoringReports: PropTypes.object,
};

export default MonitoringReportsMobile;
